import { FormControl as MuiFormControl, FormHelperText, InputLabel } from "@mui/material";
import React, { type PropsWithChildren } from "react";

import { useFieldContext } from "src/hooks";

type Props = PropsWithChildren<{
  label?: string;
}>;

export const FormControl = ({ children, label }: Props) => {
  const field = useFieldContext<string>();

  return (
    <MuiFormControl fullWidth variant="outlined" error={field.state.meta.errors.length > 0}>
      {label && <InputLabel htmlFor={field.name}>{label}</InputLabel>}
      {children}
      <FormHelperText>
        {field.state.meta.errors.map((e) => e.message || e).join(", ")}
      </FormHelperText>
    </MuiFormControl>
  );
};
